import debug from 'Helper/debugHelpers'
import _ from 'lodash'

// The form of a slice that gets written to storage: the live state with the
// replacer applied.
export const toPersistedState = (state, replacer = {}) =>
  typeof replacer === 'function' ? replacer(state) : { ...state, ...replacer }

export default (
  reducerName,
  reducer,
  replacer = {},
  actions = {},
  type = 'local'
) =>
  (state, action) => {
    const nextState = reducer(state, action)
    const { includeActions = [], excludeActions = [] } = actions
    // set local storage anytime
    if (
      !excludeActions.some(act => act === action.type) &&
      !action.type.match(/^@@(redux|INIT)/) && // exclude redux init actions
      (state !== nextState || includeActions.some(act => act === action.type))
    ) {
      debouncedFunction(action, reducerName, nextState, replacer, type)
    }
    return nextState
  }

const debouncedFunction = _.debounce((action, reducerName, nextState, replacer, type) => {
  if (!action.type.match(/^UPDATE_TIME$/)) {
    // UPDATE TIME is only excluded because it happens every second so
    // the debug log is overwhelming.
    debug.log(
      reducerName + ' storage update from action:' + action.type,
      debug.logLevels['LOCAL.STORAGE']
    )
  }
  const storedState = toPersistedState(nextState, replacer)
  const Storage = type === 'local' ? localStorage : sessionStorage
  Storage.setItem(reducerName, JSON.stringify(storedState))
}, 200)
